import React from "react";
import Menu from "../menu";
import NewsItem from "../../components/NewsList";

class News extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }


    render() {
        return (
            <div>
                <Menu selectedTab={'/news'} />
                <p>News</p>
                <NewsItem/>
            </div>
        );
    }


}

export default News;


// WEBPACK FOOTER //
// ./src/screens/news/index.js